import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M884.311012,1035.68899 L884.311012,1732.00676 L675.185528,1732.00676 L675.185528,1392.84477 L147.92568,1920 L0,1772.07432 L527.259849,1244.91909 L187.888629,1244.91909 L187.888629,1035.68899 L884.311012,1035.68899 Z M1772.11617,0 L1920.04185,147.92568 L1392.88661,675.080913 L1732.0486,675.080913 L1732.0486,884.415627 L1035.62622,884.415627 L1035.62622,187.888629 L1244.96093,187.888629 L1244.96093,527.155233 L1772.11617,0 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconExitFullScreenSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconExitFullScreenSolid, _Component);

  var _super = _createSuper(IconExitFullScreenSolid);

  function IconExitFullScreenSolid() {
    _classCallCheck(this, IconExitFullScreenSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconExitFullScreenSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconExitFullScreen",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconExitFullScreenSolid.displayName = "IconExitFullScreenSolid";
  return IconExitFullScreenSolid;
}(Component);

IconExitFullScreenSolid.glyphName = 'exit-full-screen';
IconExitFullScreenSolid.variant = 'Solid';
IconExitFullScreenSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconExitFullScreenSolid;
export { IconExitFullScreenSolid };